export const getRole = () => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    if (!authUser || !authUser.user) return "user";

    switch (authUser.user.user_type) {
      case "1":
      case 1:
        return "user";
      case "2":
      case 2:
        return "artist";
      case "3":
      case 3:
        return "admin";
      default:
        return "user";
    }
  } catch (e) {
    console.error("Error parsing authUser", e);
    return "user";
  }
};